import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import PropTypes from "prop-types";
import { hasEditorContent } from "./hasEditorContent";

export const CustomOnChangePlugin = ({ onChange }) => {
    return (
        onChange && (
            <OnChangePlugin
                onChange={(editorState) => {
                    // Emptiness is decided on the serialized state so that
                    // the editor and every hasEditorContent caller share one
                    // rule. It used to be useLexicalIsTextContentEmpty, whose
                    // value was one render behind and which counted an image
                    // only state as empty.
                    const state = editorState.toJSON();

                    onChange(hasEditorContent(state) ? state : null);
                }}
            />
        )
    );
};

CustomOnChangePlugin.propTypes = {
    onChange: PropTypes.func,
};
